export const claimsFiltering = (
  claims,
  selectedClaimsCategory,
  type,
  sortby,
  startsWith
) => {
  let filteredClaims = [];
  if (selectedClaimsCategory) {
    claims = claims.filter(
      (c) => c.claimType?.toUpperCase() === selectedClaimsCategory.toUpperCase()
    );
  }

  if (type?.length) {
    let typeSearchCriteria = type?.length > 0 ? type.split(",") : undefined;
    if (typeSearchCriteria) {
      typeSearchCriteria.map((typeSearch) => {
        if (typeSearch === "processed")
          filteredClaims.push(
            ...claims.filter(
              (c) =>
                c.deathClaimStatus === "97" ||
                c.deathClaimStatus === "99" ||
                c.claimStatus?.toUpperCase() === "A" ||
                c.claimStatus?.toUpperCase() === "I"
            )
          );
        if (typeSearch === "pending")
          filteredClaims.push(
            ...claims.filter(
              (c) =>
                c.deathClaimStatus === "01" ||
                c.deathClaimStatus === "1" ||
                c.claimStatus?.toUpperCase() === "P" ||
                c.claimStatus?.toUpperCase() === "O" ||
                c.claimStatus?.toUpperCase() === "R" ||
                c.claimStatus?.toUpperCase() === "W"
            )
          );
        if (typeSearch === "other")
          filteredClaims.push(
            ...claims.filter(
              (c) =>
                c.deathClaimStatus === "93" ||
                c.deathClaimStatus === "98" ||
                c.claimStatus?.toUpperCase() === "3"
            )
          );
        if (typeSearch === "denied")
          filteredClaims.push(
            ...claims.filter(
              (c) =>
                c.deathClaimStatus === "92" ||
                c.claimStatus?.toUpperCase() === "D" ||
                c.claimStatus?.toUpperCase() === "E"
            )
          );
      });
    }
    claims = filteredClaims;
  }

  if (sortby) {
    if (sortby === "newesttooldest") {
      claims = claims?.sort(function (a, b) {
        if (new Date(a.dateOfNotification) < new Date(b.dateOfNotification)) {
          return -1;
        }
        if (new Date(a.dateOfNotification) > new Date(b.dateOfNotification)) {
          return 1;
        }
        return 0;
      });
    } else if (sortby === "oldesttonewest") {
      claims = claims?.sort(function (a, b) {
        if (new Date(a.dateOfNotification) < new Date(b.dateOfNotification)) {
          return 1;
        }
        if (new Date(a.dateOfNotification) > new Date(b.dateOfNotification)) {
          return -1;
        }
        return 0;
      });
    }
  }
  if (startsWith) {
    claims = claims?.filter(
      (x) =>
        x?.oldPolicy
          ?.toLowerCase()
          ?.startsWith(startsWith?.toLowerCase().trim()) ||
        x?.firstName
          ?.toLowerCase()
          ?.startsWith(startsWith?.toLowerCase().trim()) ||
        x?.lastName?.toLowerCase()?.startsWith(startsWith?.toLowerCase().trim())
    );
  }
  return claims;
};

export const servicesFiltering = (
  services,
  selectedServicesCategory,
  type,
  sortby,
  startsWith
) => {
  let today = new Date();
  let last30days = new Date(new Date().setDate(today.getDate() - 30));
  let filteredServices = [];

  if (selectedServicesCategory && selectedServicesCategory !== "") {
    if (selectedServicesCategory === "processed")
      services = services.filter(
        (c) => c.serviceType === "97" || c.serviceType === "99"
      );
    if (selectedServicesCategory === "pending")
      services = services.filter(
        (c) => c.serviceType === "01" || c.serviceType === "1"
      );
    if (selectedServicesCategory === "other")
      services = services.filter(
        (c) => c.serviceType === "93" || c.serviceType === "98"
      );
    if (selectedServicesCategory === "denied")
      services = services.filter((c) => c.serviceType === "92");
  }
  if (type?.length) {
    let typeSearchCriteria = type?.length > 0 ? type.split(",") : undefined;
    if (typeSearchCriteria) {
      typeSearchCriteria.map((typeSearch) => {
        if (typeSearch === "processed")
          filteredServices.push(
            ...services.filter(
              (c) => c.deathClaimStatus === "97" || c.deathClaimStatus === "99"
            )
          );
        if (typeSearch === "pending")
          filteredServices.push(
            ...services.filter(
              (c) => c.deathClaimStatus === "01" || c.deathClaimStatus === "1"
            )
          );
        if (typeSearch === "other")
          filteredServices.push(
            ...services.filter(
              (c) => c.deathClaimStatus === "93" || c.deathClaimStatus === "98"
            )
          );
        if (typeSearch === "denied")
          filteredServices.push(
            ...services.filter((c) => c.deathClaimStatus === "92")
          );
      });
    }
    services = filteredServices;
  }

  if (sortby) {
    if (sortby === "newesttooldest") {
      services = services?.sort(function (a, b) {
        if (new Date(a.dateSubmitted) < new Date(b.dateSubmitted)) {
          return -1;
        }
        if (new Date(a.dateSubmitted) > new Date(b.dateSubmitted)) {
          return 1;
        }
        return 0;
      });
    } else if (sortby === "last30days") {
      services = services?.filter(
        (x) => new Date(x.dateSubmitted) >= new Date(last30days)
      );
    }
  }
  if (startsWith) {
    services = services?.filter(
      (x) =>
        x?.oldPolicy
          ?.toLowerCase()
          ?.startsWith(startsWith?.toLowerCase().trim()) ||
        x?.firstName
          ?.toLowerCase()
          ?.startsWith(startsWith?.toLowerCase().trim()) ||
        x?.lastName?.toLowerCase()?.startsWith(startsWith?.toLowerCase().trim())
    );
  }

  return services;
};
